import AccountPage from 'components/page/AccountPage.vue';
import ColumnsPage from 'components/page/ColumnsPage.vue';
import ColumnDetails from 'components/page/ColumnDetails.vue';
import DevicesPage from 'components/page/DevicesPage.vue';
import DevicePage from 'components/page/DevicePage.vue';
import MethodsPage from 'components/page/MethodsPage.vue';
import MethodPreview from '@/components/page/MethodPreview.vue';
import SamplePage from 'components/page/SamplePage.vue';
import SampleNewPage from 'components/page/SampleNewPage.vue';
import SequencePage from 'components/page/SequencePage.vue';
import SequenceNewPage from 'components/page/SequenceNewPage.vue';
import SearchPage from 'components/page/SearchPage.vue';
import ChromatogramsComparePage from 'components/page/ChromatogramsComparePage.vue';
import DeviceTerminalPage from 'components/page/DeviceTerminalPage.vue';
import OrganizationPage from '@/components/page/OrganizationPage.vue';
import InvitationToOrganizationPage from '@/components/page/InvitationToOrganizationPage.vue';
import PostprocessingTemplatesPage from '@/components/page/PostprocessingTemplatesPage.vue';
import StandardPage from '@/components/page/StandardPage.vue';

const defaultMode = {
  path: '',

  component: () => import('@/layouts/Default.vue'),
  children: [
    {
      path: '/',
      redirect: '/devices/',
    },
    {
      path: '/devices/',
      name: 'devices',
      meta: {
        colorBg: 'gray',
      },
      component: DevicesPage,
    },
    {
      path: '/devices/:id([a-zA-Z0-9]+)/',
      name: 'device',
      component: DevicePage,
      props: (route) => ({ id: route.params.id }),
    },
    {
      path: '/devices/:id([a-zA-Z0-9]+)/terminal/',
      name: 'deviceTerminal',
      component: DeviceTerminalPage,
      props: (route) => ({ id: route.params.id }),
    },
    {
      path: '/samples/',
      name: 'samples',
      component: SearchPage,
    },
    {
      path: '/samples/new/',
      name: 'sample new',
      meta: {
        colorBg: 'gray',
      },
      component: SampleNewPage,
    },
    {
      path: '/samples/:id(\\d+)/',
      name: 'sample',
      component: SamplePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({ id: parseInt(route.params.id, 10), iid: null }),
    },
    {
      path: '/samples/:id(\\d+)/injection/:iid(\\d+)/',
      name: 'sample injection',
      component: SamplePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        iid: parseInt(route.params.iid, 10),
      }),
    },
    {
      path: '/samples/:id(\\d+)/injection/new/',
      name: 'sample injection new',
      component: SamplePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        iid: -1,
      }),
    },
    {
      path: '/standards/:id(\\d+)/',
      name: 'standard',
      component: StandardPage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({ id: parseInt(route.params.id, 10), iid: null }),
    },
    {
      path: '/standards/:id(\\d+)/injection/:iid(\\d+)/',
      name: 'standard injection',
      component: StandardPage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        iid: parseInt(route.params.iid, 10),
      }),
    },
    {
      path: '/chromatograms-compare/',
      name: 'chromatograms compare',
      component: ChromatogramsComparePage,
      props: (route) => {
        let ids = null;
        try {
          ids = route.query.ids?.split('.')?.map((i) => parseInt(i, 10));
        } catch (e) {
          //stub
        }

        return {
          ids,
        };
      },
    },
    {
      path: '/sequences/',
      name: 'sequences',
      component: SearchPage,
    },
    {
      path: '/sequences/new/',
      name: 'sequence new',
      component: SequenceNewPage,
      meta: {
        colorBg: 'gray',
      },
    },
    {
      path: '/sequences/:id(\\d+)/',
      name: 'sequence',
      component: SequencePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({ id: parseInt(route.params.id, 10), sid: null, iid: null }),
    },
    {
      path: '/sequences/:id(\\d+)/calibrations/:calibrationId(\\d+)?/',
      name: 'sequence calibrations',
      component: SequencePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        sid: null,
        iid: null,
        calibrationId:
          route.params.calibrationId != null ? parseInt(route.params.calibrationId, 10) : null,
      }),
    },
    {
      path: '/sequences/:id(\\d+)/results/',
      name: 'sequence results',
      component: SequencePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        sid: null,
        iid: null,
        calibrationId: null,
      }),
    },
    {
      path: '/sequences/:id(\\d+)/reports/',
      name: 'sequence reports',
      component: SequencePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        sid: null,
        iid: null,
        calibrationId: null,
      }),
    },
    {
      path: '/sequences/:id(\\d+)/:sid(\\d+)',
      name: 'sequence child',
      component: SequencePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        sid: parseInt(route.params.sid, 10),
        iid: null,
      }),
    },
    {
      path: '/sequences/:id(\\d+)/:sid(\\d+)/:iid(\\d+)',
      name: 'sequence child injection',
      component: SequencePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        sid: parseInt(route.params.sid, 10),
        iid: parseInt(route.params.iid, 10),
      }),
    },
    {
      path: '/sequences/:id(\\d+)/:sid(\\d+)/new',
      name: 'sequence child injection new',
      component: SequencePage,
      meta: {
        colorBg: 'dark-gray',
      },
      props: (route) => ({
        id: parseInt(route.params.id, 10),
        sid: parseInt(route.params.sid, 10),
        iid: -1,
      }),
    },
    {
      path: '/search/',
      name: 'search',
      component: SearchPage,
    },
    {
      path: '/columns/',
      name: 'columns',
      component: ColumnsPage,
    },
    {
      path: '/columns/:columnId(\\d+)/',
      name: 'columnDetails',
      component: ColumnDetails,
      props: (route) => ({
        columnId: Number(route.params.columnId),
      }),
    },
    {
      path: '/methods/',
      name: 'methods',
      component: MethodsPage,
    },
    {
      path: '/methods/preview/:methodId(\\d+)/',
      name: 'methodPreview',
      component: MethodPreview,
      props: (route) => ({
        methodId: Number(route.params.methodId),
        injectionId: route.query.injectionId ? Number(route.query.injectionId) : null,
      }),
    },
    {
      path: '/postprocessing-templates/',
      name: 'postprocessingTemplates',
      component: PostprocessingTemplatesPage,
    },
    {
      path: '/account/',
      name: 'account',
      meta: {
        colorBg: 'gray',
      },
      component: AccountPage,
    },
    {
      path: '/organization/',
      name: 'organization',
      meta: {
        colorBg: 'gray',
      },
      component: OrganizationPage,
    },
    {
      path: '/invitation-to-organization/:token/',
      name: 'invitationToOrganization',
      meta: {
        colorBg: 'gray',
      },
      component: InvitationToOrganizationPage,
    },
  ],
};

export default defaultMode;
